import React from 'react';
import PropTypes from 'prop-types';
import './lead-magnet.scss';

const LeadMagnet = ({ src, mobileSrc }) => (
  <div className="lead-magnet mt-2">
    {/* Desktop */}
    <iframe
      title="remoteteam-banner"
      src={src}
      className="lead-magnet-iframe-desktop"
      width="100%"
      height="100%"
      scrolling="no"
      frameBorder="0"
      allowtransparency="true"
      allow="autoplay"
      allowFullScreen
    />
    {/* Mobile */}
    <iframe
      title="remoteteam-banner"
      src={mobileSrc}
      className="lead-magnet-iframe-mobile"
      width="100%"
      height="100%"
      scrolling="no"
      frameBorder="0"
      allowtransparency="true"
      allow="autoplay"
      allowFullScreen
    />
  </div>
);

LeadMagnet.propTypes = {
  src: PropTypes.string.isRequired,
  mobileSrc: PropTypes.string.isRequired,
};

export default LeadMagnet;
